import * as React from 'react';
import { Text, View } from 'react-native';
import { Paragraph } from 'react-native-paper';

export function CustomBullet(props) {
  const { children, ...nonChildrenProps } = props;
  if (!nonChildrenProps) {
    nonChildrenProps = {};
  }
  return (
    <View
      style={{
        flexDirection: "row",
        paddingBottom: 4,
      }}
    >
      <Text>•</Text>
      <Paragraph
        {...nonChildrenProps}
        style={{
          flex: 1,
          paddingLeft: 5,
          ...nonChildrenProps.style,
        }}
        selectable={true}
      >
        {children}
      </Paragraph>
    </View>
  );
}
